export const mediums = [];

export const mediumTipoCitaMappingPreventa = [
  { key: 'arkeero', value: 'Arkeero' },
  { key: 'usmedia', value: 'USMedia' },
  { key: 'antevenio', value: 'Antevenio' },
  { key: 'notonlymedia', value: 'NOM1' },
  { key: 'plm', value: 'PLM' },
  { key: 'linkstudio', value: 'Linkstudio' },
  { key: 'latamconnec', value: 'Latam Connect' }
];

export const mediumTipoCitaMappingHardsell = [
  { key: 'arkeero', value: 'Arkeero' },
  { key: 'usmedia', value: 'USmedia' },
  { key: 'antevenio', value: 'Antevenio' },
  { key: 'automovilpanamericano', value: 'Automovil Panamericano' },
];